import { render, staticRenderFns } from "./SpacingView.vue?vue&type=template&id=6de440ae&scoped=true"
import script from "./SpacingView.vue?vue&type=script&lang=js"
export * from "./SpacingView.vue?vue&type=script&lang=js"
import style0 from "./SpacingView.vue?vue&type=style&index=0&id=6de440ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de440ae",
  null
  
)

export default component.exports